import * as React from 'react';
import * as Configuration from '../../../configuration';
import ScanChart, { ChartDatum } from '../ScanChart';
import TimeSummary from './TimeSummary';


class CustomGraphs extends React.PureComponent<any, any> {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        const sumQuestionsData : ChartDatum[] = this.props.sumQuestionsData;
        var defaultColors = Configuration.custom.defaultGraphColors;
        let seasonGraphs = undefined;
        
        return (
            <div className="row no-gutters">
                <div className="col-6">
                    <ScanChart
                        chartType='ColumnChart'
                        collate={false}
                        colors={defaultColors}
                        data={sumQuestionsData}
                        defaultClosed={undefined}
                        discrete={undefined}
                        displayIcon={undefined}
                        groupBy={undefined}
                        height="130px"
                        legend="none"
                        title="Sightings by Season"
                        width={undefined}
                    />
                </div>
                <div className="col-6">
                    <TimeSummary
                        title="Time of Day"
                        className={undefined}
                        //colors={defaultColors}
                        height={undefined}
                    />
                </div>
                {seasonGraphs}
            </div>
        );
    }
}

export default CustomGraphs;
